import { kasplexMainnetTokens } from '@pancakeswap/tokens'
import { FeeAmount } from '@pancakeswap/v3-sdk'
import { getAddress } from 'viem'
import { SerializedFarmConfig } from '..'
import { defineFarmV3Configs } from '../src/defineFarmV3Configs'

export const farmsV3 = defineFarmV3Configs([
  {
    pid: 5,
    lpAddress: '0x207412367e06e26c0367fb3609acd0f92137a4ae',
    token0: kasplexMainnetTokens.usdc,
    token1: kasplexMainnetTokens.wkas,
    feeAmount: FeeAmount.LOW,
  },
  {
    pid: 6,
    lpAddress: '0x75d4d745e6e3f1ecafb3a7e8522ca8500caf4370',
    token0: kasplexMainnetTokens.wkas,
    token1: kasplexMainnetTokens.usdt,
    feeAmount: FeeAmount.MEDIUM,
  },
  {
    pid: 7,
    lpAddress: '0x284f9ae617f25186c5d8a1cf81b1ddecbd506cd8',
    token0: kasplexMainnetTokens.wkas,
    token1: kasplexMainnetTokens.wbnb,
    feeAmount: FeeAmount.MEDIUM,
  },
  {
    pid: 1,
    lpAddress: '0x6469dba0ac4becf7833ac1801d808f579731e6d5',
    token0: kasplexMainnetTokens.wkas,
    token1: kasplexMainnetTokens.zeal,
    feeAmount: FeeAmount.LOW,
  },
  {
    pid: 2,
    lpAddress: '0x8d99af257fadca4448bc87af12e5c646b4842699',
    token0: kasplexMainnetTokens.wkas,
    token1: kasplexMainnetTokens.nacho,
    feeAmount: FeeAmount.LOW,
  },
  {
    pid: 3,
    lpAddress: '0xff6321e5f990c559a17fe7a26e8d19ff7604c51f',
    token0: kasplexMainnetTokens.wkas,
    token1: kasplexMainnetTokens.test,
    feeAmount: FeeAmount.LOWEST,
  },
  {
    pid: 4,
    lpAddress: '0x033d6c5b469bef1191a146ec16b512f4d17267fe',
    token0: kasplexMainnetTokens.kasper,
    token1: kasplexMainnetTokens.wkas,
    feeAmount: FeeAmount.LOW,
  },
])

// TODO: Re-enable farm configurations below when ready to activate farms functionality.
// The array is currently empty, so no farms will be available.
const farms: SerializedFarmConfig[] = [].map((p) => ({
  ...p,
  token: p.token.serialize,
  quoteToken: p.quoteToken.serialize,
  lpAddress: getAddress(p.lpAddress),
}))

export default farms
